export * from './lib/pages/protection-details-wib/protection-details-wib.component';
export * from './lib/us-registration-feature-protection-details.routes';
